import { supportEmail, naira } from './utils';

export const DOM_EXCEPTION_CODES = {
  ABORT_ERROR: 20
};

const errors = {
  authProviderConnectionError: (
    <div>
      Auth provider connection error. Please contact <a href={`mailto: ${supportEmail}`}>{supportEmail}</a>
    </div>
  ),
  tokenIsNotValid: 'Your authorization token is not valid.',
  internalServerError: 'The server encountered an internal error that prevented it from fulfilling this request.',
  badRequest: 'There was a request timeout. An error occurred while processing your server request.',
  noKeycloakConnection: 'There was a problem with connection to the Keycloak server.',
  noNetworkConnection: 'There was a problem with your network connection.',
  tokenWasNotUpdated: 'Token was not updated.',
  somethingWentWrong: (
    <>
      Something went wrong. Please contact <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
    </>
  ),
  reportsLimitReached: 'Reports limit reached.',
  pendingReportsLimitReached: 'Pending Reports limit reached.',
  reportNotFound: 'Report not found.',
  apiVersionMismatch: 'There was a problem with USSD API version.',
  inReportsDetailsLimitReachedMsg: (option: 'regenerate' | 'retry') =>
    ` The ${option} option is disabled due to the limit reached.`,
  orderNotFound: 'Something goes wrong while processing your settings confirmation. Please try again.',
  operationNotFound: 'Operation with specific Id not found'
};

export const FORM_INPUT_ERROR_MSGS = {
  REQUIRED: (inputName: string) => `Please enter ${inputName.toLowerCase()}.`,
  REQUIRED_SELECT: (selectName: string) => `Please select ${selectName.toLowerCase()}.`,
  INVALID_FORMAT: (inputName: string, format: string | RegExp = '', example: string = '') => {
    const formatMsg = format ? `in a valid ${format} format` : `in a valid format`;
    const exampleMsg = example ? ` For example ${example}` : '';

    return `Please enter ${inputName.toLowerCase()} ${formatMsg}.${exampleMsg}`;
  },
  MAX: 'You have reached maximum limit of characters allowed.',
  EXACT: (field: string, size: number, typeOfValue: 'chars' | 'digits' = 'chars') =>
    `${field} need to have exact ${size} ${typeOfValue}`,
  DIGIT: (field: string) => `Please provide ${field} as a digit value`,
  UNIQUE: (field: string) => `This ${field} already exist. Please enter unique value.`,
  END_DATE_BEFORE_START: 'End date must be after Starting date',
  MAX_VALUES_LIMIT: (limit: number) => `You can define maximum ${limit} values`,
  CUSTOM: (message: string) => message,
  MIN: (number: number, field: string) => `You need to provide at least ${number} ${field}`,
  AMOUNT: () => `The amount must be at least ${naira}1.`,
  SMS_TEMPLATE: () => 'Sms template must contains {link}',
  MSISDN_SIMPLE: () =>
    // eslint-disable-next-line max-len
    `Please enter phone number in a valid format. The phone number needs to start with "+", next your country code, and the local part of it. The provided number can be between 7 and 13 digits long. For example +2341112223333.`
};

enum BUSINESS_API_ERRORS {
  'INCORRECT_MSISDN' = 'INCORRECT_MSISDN',
  'MSISDN_ALREADY_USED' = 'MSISDN_ALREADY_USED',
  'EMAIL_ALREADY_EXISTS' = 'EMAIL_ALREADY_EXISTS',
  'OTP_VERIFICATION_ERROR' = 'OTP_VERIFICATION_ERROR',
  'CLIENT_TO_CONFIRM_DOES_NOT_EXIST' = 'CLIENT_TO_CONFIRM_DOES_NOT_EXIST',
  'PENDING_CLIENT_PROFILE_EXPIRED' = 'PENDING_CLIENT_PROFILE_EXPIRED'
}

export const UNEXPECTED_ERROR = 'The server responded with an unexpected error.';
export const SUPPORT_CONTACT = (
  <p>
    Please contact <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
  </p>
);

export const apiCodeBusinessErrorsMapper = (errorMsg: BUSINESS_API_ERRORS | string): string => {
  switch (errorMsg) {
    case BUSINESS_API_ERRORS.INCORRECT_MSISDN:
      return `Your phone number could not be handled by the server.
      Specify another number or contact support@qrios.com`;

    case BUSINESS_API_ERRORS.MSISDN_ALREADY_USED:
      return 'Account corresponding to this phone number already exists. Specify another number.';

    case BUSINESS_API_ERRORS.EMAIL_ALREADY_EXISTS:
      return 'Account corresponding to this client already exists. Specify another client.';

    case BUSINESS_API_ERRORS.CLIENT_TO_CONFIRM_DOES_NOT_EXIST:
      return 'The client you want to create an account for, does not exist. Try to register again.';
    case BUSINESS_API_ERRORS.OTP_VERIFICATION_ERROR:
      return 'Your OTP codes do not match. Please try again.';
    case BUSINESS_API_ERRORS.PENDING_CLIENT_PROFILE_EXPIRED:
      return 'Pending account corresponding to this client expired. Start again profile creation process.';
    default:
      if (typeof errorMsg === 'string') return errorMsg;
      return UNEXPECTED_ERROR;
  }
};

export default errors;
